import { TRANSACTION_ROUTES } from '@features/transaction/routes';
import { useCheckAuth } from '@features/user/states';
import { LoadingScreen } from '@g2-shared/components';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

interface Props {
  children: React.ReactNode;
}

export const GuestGuard = ({ children }: Props) => {
  const { isAuthenticated, isLoading } = useCheckAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(TRANSACTION_ROUTES.home);
    }
  }, [isAuthenticated]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
};
